const keys = {
  userToken: "palmabay_admin_UserToken"
};

const getStorage = (key) => localStorage.getItem(key);
const setStorage = (key, value) => localStorage.setItem(key, value);
const removeStorage = (key) => localStorage.removeItem(key);


const storage = {
  userToken: {
    get: () => getStorage(keys.userToken),
    set: (value) => setStorage(keys.userToken, value),
    remove: () => removeStorage(keys.userToken)
  }
};

export default storage;
